/**
 * Renders an image and texts when there is no content.
 * Get inspiration from: https://emptystat.es/
 *
 * Copyright (c) 2020 Propellant Software Corp
 * Author: Yucho Ho
 */
import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import './EmptyStates.scss'

const EmptyStates = ({
  className,
  image,
  text
}) => {
  const emptyStateClass = cx(className, 'empty-state-container')

  return (
    <div className={emptyStateClass}>
      <div className='p-2'>
        {image}
      </div>
      <div className='p-2 nothing-here-text'>{text}</div>
    </div>
  )
}

EmptyStates.propTypes = {
  className: PropTypes.string,
  image: PropTypes.node,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
}

EmptyStates.defaultProps = {
  image: <img src='/static/assets/img/illustrations/no-data.svg' className='empty-states-img' />,
  text: 'Hmm, there\'s nothing here, yet.'
}

export default EmptyStates
